<template>
    <div class="vant-field-attachment">
        <van-field :label="label" :required="required" :readonly="readonly" v-model="text"
                   :placeholder="placeholder"  :style="cellStyle" type="textarea" autosize/>
    </div>
</template>
<script>
    import {Field} from 'vant';
    import attachmentService from "../service/attachmentService";

    export default {
        name: 'VanFieldAttachment',
        components: {
            [Field.name]: Field
        },
        data() {
            return {
                text: ""
            }
        },
        props: {
            label: {
                type: String,
                default: null
            },
            value: {
                type: String,
                default: null
            },
            readonly: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: ''
            },
            cellStyle: {
                type: Object,
                default: null
            }
        },
        methods: {
            async getText() {
                let resp = await attachmentService.getAttachmentsByIds(this.value);
                if (resp.data.Status === "1") {
                    var attachments="";
                    resp.data.Data.forEach(item =>{
                        attachments += '📎 ';
                        attachments += item.filename+"\n" ;
                    });
                    this.text = attachments;
                }
            }
        },
        watch: {
            async value() {
                this.getText();
            }
        },
        mounted: function () {
            this.getText();
        },
        computed: {}
    }
</script>
<style>
    .vant-field-attachment>.van-cell>.van-cell__title {
        text-align: right;
        margin-right:1rem;
    }
    .vant-field-attachment>.van-cell--required::before {
        left: 107px;
        top: 13px;
    }
</style>